import { useState } from "react";
import { useAuth } from "../../../../modules/auth";
import { ControlType, Property } from "../../../base/types";
import { Registry } from "../../../base/register";
import { useGetIncident } from "./properties/useGetIncident";
import moment from "moment";
import { IControlAttributes, ITableLookup } from "../../../base/models";
import { IncidentProperties } from "./properties";
import { Chat, ChatWrapper } from "../chat";
import { useGetProperties } from "../../../base/hooks";

const incidentStatus = (status: number) => {
    switch (status) {
        case 1: return "In Progress";
        case 365970000: return "Pending";
        case 365970001: return "Completed";
        case 2: return "Inactive";
        default: return "Unknown";
    }
};

const statusBadgeClasses = (status: number) => {
    switch (status) {
        case 1: // In Progress
            return ["badge", "bg-primary", "text-white", "text-center"];
        case 365970001: // Completed
            return ["badge", "bg-success", "text-white", "text-center"];
        case 365970000: // Pending
            return ["badge", "bg-warning", "text-white", "text-center"];
        case 2: // Inactive.
            return ["badge", "bg-grey", "text-white", "text-center"];
        default:
            return ["badge", "bg-black", "text-dark", "text-center"];
    }
};

export const IncidentReportingComponent = (props: IControlAttributes) => {
    const { control } = props;
    const { properties } = useGetProperties({ bindings: control.bindings });
    const { user } = useAuth();
    const { incidents } = useGetIncident();
    const entity: string | undefined = properties[Property.Entity];
    const title: string | undefined = properties[Property.Title];
    const headerClass: string | undefined = properties[Property.HeaderClass];
    const collapsible: boolean | undefined = properties[Property.Collapsible];
    const tableLookup: ITableLookup = properties[Property.TableLookup] || {};
    const [openChat, setOpenChat] = useState<{ [key: string]: boolean }>({});

    const toggleChat = (incidentId: string) => {
        setOpenChat(prev => ({
            ...prev,
            [incidentId]: !prev[incidentId]
        }));
    };

    const filteredIncidents = incidents.filter(incident => incident.status !== 2);

    return (
        <>
            {filteredIncidents.map((incident) => (
                <div key={incident.incidentId} className="card p-3 mb-3 border border-dark rounded wrap">
                    <div className="row g-3">
                        <div className="col-6 col-lg-3 ms-lg-2 mb-1 me-lg-1">
                            <strong>Incident ID</strong><br />
                            <div className="text-primary">{incident.incidentId}</div>
                        </div>

                        <div className="col-6 col-lg-3 mb-1">
                            <strong>Incident</strong><br />
                            {incident.incident}
                        </div>

                        <div className="col-6 col-lg-2 mb-1 me-lg-6">
                            <strong>Incident Date & Time</strong><br />
                            {moment(incident.incidentDate).format("DD MMM YYYY HH:mm")}
                        </div>

                        <div className="col-6 col-lg-2 mb-1 me-lg-15 text-lg-center">
                            <strong>Status</strong><br />
                            <div className="d-inline-block">
                                <div className={`me-2 ms-lg-2 mt-1 rounded-pill ${statusBadgeClasses(incident.status).join(' ')}`}>
                                    {incidentStatus(incident.status)}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-1 mb-1 text-lg-end">
                            <button
                                className="btn btn-secondary"
                                onClick={() => toggleChat(incident.incidentId)}
                            >
                                Chat
                            </button>
                        </div>
                    </div>

                    <div
                        className={`offcanvas offcanvas-end ${openChat[incident.incidentId] ? "show" : ""}`}
                        tabIndex={-1}
                        id={`chatOffcanvas-${incident.incidentId}`}
                        aria-labelledby={`chatOffcanvasLabel-${incident.incidentId}`}
                    >
                        <div className="offcanvas-header bg-light-purple" style={{ backgroundColor: '#c5cae9' }}>
                            <h5 className="offcanvas-title" id={`chatOffcanvasLabel-${incident.incidentId}`}>
                                <span className="text-dark">Incident ID :   </span>
                                <span className="text-primary">{incident.incidentId}</span>
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => toggleChat(incident.incidentId)}
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="offcanvas-body">
                            {entity && incident.id ?
                                <ChatWrapper
                                    title={title}
                                    icon="ChatOutlined"
                                    headerClass={headerClass}
                                    collapsible={collapsible}
                                    entity={entity}
                                    tableLookup={tableLookup}
                                    contactId={user?.contactId}
                                    entityId={incident.id} /> :
                                <Chat
                                    title={title}
                                    icon="ChatOutlined"
                                    headerClass={headerClass}
                                    collapsible={collapsible}
                                    messages={[]}
                                    contactId={user?.contactId}
                                    tableLookup={tableLookup}
                                    onSendMessage={() => { }} />
                            }
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

Registry.addControl({
    id: "f811dbb6-4bef-4f00-95f3-6d8f4b8341a1",
    name: "Incident Reporting",
    type: ControlType.IncidentReportingComponent,
    properties: IncidentProperties,
    component: IncidentReportingComponent
});
